import GATSBY_COMPILED_MDX from "/home/runner/work/2027.datameshlive.com/2027.datameshlive.com/content/speakers/jacqui-read.mdx";
import * as React from "react";
import {graphql} from "gatsby";
import {speakerPictureThumb} from "../api";
import Main, {LightContentBlock, MainTitle} from "../components/Main";
import {TicketButton} from "../components/Button";
import {MDXProvider} from "@mdx-js/react";
import {Link} from "gatsby";
const shortcodes = {
  Link
};
function Session({data, children}) {
  const {fullName, ...speaker} = data.mdx.frontmatter;
  return React.createElement(Main, {
    title: `Data Mesh Live 2027 - ${fullName}`
  }, React.createElement(MainTitle, {
    title: fullName
  }, speaker.question_what_are_your_pronouns && React.createElement("div", {
    className: "-mt-4 mb-2 font-medium"
  }, " ", "(", speaker.question_what_are_your_pronouns.toLowerCase(), ")"), React.createElement("div", null, React.createElement("img", {
    className: "sm:aspect-3/2 first:ml-0 -ml-2 rounded-2xl border-accent border-2 w-full sm:h-64 object-cover",
    src: speakerPictureThumb(speaker),
    alt: speaker.fullName,
    key: speaker.id
  }), React.createElement("ul", {
    className: "flex gap-2 flex-wrap mt-2"
  }, speaker.links.map(({title, url}) => React.createElement("li", null, React.createElement("a", {
    className: "text-base underline",
    href: url
  }, title)))))), React.createElement(LightContentBlock, null, React.createElement("div", {
    className: "sm:flex gap-4"
  }, React.createElement("div", {
    className: "flex flex-col"
  }, React.createElement("div", {
    className: "text-primary-content"
  })), React.createElement("div", {
    className: "prose"
  }, React.createElement(MDXProvider, {
    components: shortcodes
  }, children)))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(Session, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const query = graphql`
  query ($id: String!) {
    mdx(id: { eq: $id }) {
      frontmatter {
        fullName
        id
        question_cloudinary_photo_url
        question_what_are_your_pronouns
        profilePicture
        links {
          title
          url
        }
      }
    }
  }
`;
